export const LENS_MAINNET_RPCS = [
  "https://rpc.lens.xyz",
  "https://api.lens.matterhosted.dev",
  "https://lens-mainnet.g.alchemy.com/v2/N_HuqeYE3mr_enxw-BGFI2rOm1U7bhGy"
];

export const LENS_TESTNET_RPCS = [
  "https://rpc.testnet.lens.dev",
  "https://lens-sepolia.g.alchemy.com/v2/N_HuqeYE3mr_enxw-BGFI2rOm1U7bhGy"
];

export const BSC_TESTNET_RPCS = [
  "https://data-seed-prebsc-1-s1.bnbchain.org:8545",
  "https://data-seed-prebsc-2-s1.bnbchain.org:8545",
  "https://data-seed-prebsc-1-s2.bnbchain.org:8545",
  "https://data-seed-prebsc-2-s2.bnbchain.org:8545",
  "https://data-seed-prebsc-1-s3.bnbchain.org:8545",
  "https://data-seed-prebsc-2-s3.bnbchain.org:8545",
  "https://bsc-testnet-rpc.publicnode.com",
  "https://bsc-testnet.drpc.org"
];

export const BSC_MAINNET_RPCS = [
  "https://bsc-dataseed.bnbchain.org",
  "https://bsc-dataseed1.bnbchain.org",
  "https://bsc-dataseed2.bnbchain.org",
  "https://bsc-dataseed3.bnbchain.org",
  "https://bsc-dataseed4.bnbchain.org",
  "https://bsc-rpc.publicnode.com",
  "https://bsc.drpc.org",
  "https://binance.llamarpc.com",
  "https://bsc-dataseed1.defibit.io",
  "https://bsc-dataseed.nariox.org"
];
